/**
 * @file Discover Album Folder Purchase - Uniform tag selection view.
 */

import React from 'react';

import AlbumFolderPurchaseUniformTagSelectionContainer from '../../containers/purchase/album-folder-purchase/AlbumFolderPurchaseUniformTagSelectionContainer';

const AlbumFolderPurchaseUniformTagSelectionView = () => (
  <AlbumFolderPurchaseUniformTagSelectionContainer />
);

export default AlbumFolderPurchaseUniformTagSelectionView;
